import React, { useEffect, useMemo, useState } from 'react'
import logoSandre from 'assets/pictures/logo_sandre.png'
import { push } from '@lagunovsky/redux-react-router'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import useActions from 'utils/customHook/useActions'
import useTitle from 'utils/customHook/useTitle'
import { getDataWithHeaders } from 'utils/ExportDataUtil'
import { sandreSupportAllLink } from '../../../../conf/SieauConstants'
import HomeAction from '../../../../home/actions/HomeAction'
import {
    PATH_REFERENCIAL,
    PATH_REFERENCIAL_SUPPORT,
    PATH_REFERENCIAL_SUPPORT_NEW,
} from '../../../../home/constants/RouteConstants'
import ReferencialAction from '../../../action/ReferencialAction'
import SupportAction from '../actions/SupportAction'
import {
    nbPerPageLabel,
    REFERENCIAL_TYPE_NAME,
    REFERENTIAL_JOBSYNC_ID,
} from 'referencial/constants/ReferencialConstants'
import Select from 'components/forms/Select'
import Input from 'components/forms/Input'
import { Button, Card, CardContent, Grid2, Stack } from '@mui/material'
import { searchAllCharacters } from 'utils/StringUtil'
import { hasValue } from 'utils/NumberUtil'
import useSessionStorage from 'utils/customHook/useSessionStorage'
import { getStatusInformation } from 'referencial/util/StatusUtils'
import { reloadJobSync } from '../../../util/ReferencialUtils'
import JobSyncStatus from '../../JobSyncStatus'
import { CardTitle } from 'components/card/NewCard'
import { CardTable } from 'components/datatable/NewTable'

const headers = ['code', 'name', 'status']

const SupportsApp = () => {
    const {
        supports,
        referencialStatus,
    } = useSelector(store => ({
        supports: store.SupportReducer.supports,
        referencialStatus: store.ReferencialReducer.referencialStatus,
    }), shallowEqual)

    const [filter, setFilter] = useSessionStorage(`referencial_${REFERENCIAL_TYPE_NAME.support}`, {})
    const [filterTmp, setFilterTmp] = useState(filter)
    const [jobSync, setJobSync] = useState(undefined)

    useEffect(() => {
        reloadJobSync(REFERENTIAL_JOBSYNC_ID.support, setJobSync)
    }, [])

    useEffect(() => {
        if (jobSync && jobSync.executions[0]) {
            if (!jobSync.executions[0].statusCode) {
                setTimeout(() => {
                    reloadJobSync(REFERENTIAL_JOBSYNC_ID.support, setJobSync)
                }, 5000)
            }
        }
    }, [jobSync])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(SupportAction.fetchSupports())
        dispatch(HomeAction.setHelpLink('', ''))
        if (!referencialStatus.length) {
            dispatch(ReferencialAction.fetchReferencialStatus())
        }
    }, [])

    useTitle(() => [{
        title: i18n.referencials,
        href: PATH_REFERENCIAL,
    }, {
        title: i18n.supports,
        href: PATH_REFERENCIAL_SUPPORT,
    }], [])

    const supportsByStatus = useMemo(() => hasValue(filter.status) ? supports.filter(h => parseInt(h.status) === filter.status) : supports, [filter.status, supports])
    const data = useMemo(() => {
        return supportsByStatus
            .filter((obj) => searchAllCharacters(headers.map((key) => obj[key]).join())
                .includes(searchAllCharacters(filter.searchValue || '')))
    }, [supportsByStatus, filter])

    useActions(() => {
        return {
            new: () => dispatch(push(PATH_REFERENCIAL_SUPPORT_NEW)),
            referencialActions: {
                actions: {
                    export: {
                        data: getDataWithHeaders(data, headers),
                        titleFile: i18n.supportsList,
                    },
                    sync: {
                        updateAction: options => dispatch(ReferencialAction.launchSyncJob(REFERENTIAL_JOBSYNC_ID.support, options, () => reloadJobSync(REFERENTIAL_JOBSYNC_ID.support, setJobSync))),
                        withInsertAllOption: true,
                    },
                    purge: {
                        onPurge: () => dispatch(SupportAction.purgeSupport()),
                    },
                },
            },
            links: [{
                href: sandreSupportAllLink,
                img: logoSandre,
                label: i18n.sandre.toUpperCase(),
            }],
        }
    }, [data])

    const dataFormatted = useMemo(() => data.map(s => ({
        ...s,
        code: { value: s.code, sortValue: s.code },
        name: { value: s.name, sortValue: s.name },
        status: { value: s.status ? getStatusInformation(s.status.toString()) : '', sortValue: s.status },
        colorLine: s.active === '1' ? undefined : '#c5c5c5',
    })), [data])

    return (
        <Stack margin={1} spacing={1}>
            <Card>
                <CardTitle title={i18n.criterias} color='bannerColor'/>
                <CardContent>
                    <Grid2 spacing={1} container>
                        <Grid2 size={3}>
                            <Input
                                title={i18n.search}
                                value={filterTmp.searchValue}
                                onChange={v => setFilterTmp({ ...filterTmp, searchValue: v })}
                                onEnterKeyPress={() => setFilter({ ...filterTmp })}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <Select
                                options={referencialStatus}
                                label={i18n.status}
                                onChange={v => setFilterTmp({ ...filterTmp, status: v })}
                                value={filterTmp.status}
                                nullLabel='&nbsp;'
                            />
                        </Grid2>
                        <Grid2 size={5}>
                            <JobSyncStatus jobSync={jobSync}/>
                        </Grid2>
                        <Grid2 size={1} marginTop='15px'>
                            <Button className='right' onClick={() => setFilter({ ...filterTmp })} variant='contained' color='primary'>
                                {i18n.search}
                            </Button>
                        </Grid2>
                    </Grid2>
                </CardContent>
            </Card>
            <CardTable
                title={i18n.supportsList}
                rowsPerPageOptions={nbPerPageLabel}
                rows={dataFormatted}
                color='bannerColor'
                headers={headers}
                onClickRow={support => dispatch(push(`/referencial/support/${support.id}/dashboard`))}
            />
        </Stack>
    )
}

export default SupportsApp
